
export class ReferralSuccess {

    public success: boolean = true;
    public successMessge: string = '';
    public errorCode: any;
    public pageNumber: number = 0;
    public pageSize: number = 0;
    public resultSize: number = 0;
    public referralUrl: string = '';
    public referralCode: string = '';
    public appShareInfo: string = '';
}
